export const environment = {
  production: true,
  apiUrl: 'https://api-sim.minjusticia.gov.co/siup',
  resetPassword: 'E6TvPfT'
};

//https://api-sim.minjusticia.gov.co/siup
//http://192.168.8.103:9191
